import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import {
    Button,
    Card,
    Form,
    Input,
    Select,
    Upload,
    Table,
    Space
} from "antd";

import {
    UploadOutlined,
    PlusOutlined,
    DeleteOutlined,
    ArrowLeftOutlined,
    EditOutlined,
} from "@ant-design/icons";

import { useState } from "react";
import Layout from "../../Layout";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ProductVersionModal from "./ProductVersionModal";

const { TextArea } = Input;

export default function CreateProduct() {
  const { t } = useTranslation();
    const [description, setDescription] = useState("");
    const navigate = useNavigate();
    const [openVersionModal, setOpenVersionModal] = useState(false);

    const [versions, setVersions] = useState<any[]>([
        { id: Date.now() }
    ]);

    /* ADD VERSION */

    const addVersion = (data: any) => {
        setVersions(prev => [
            ...prev,
            {
                id: Date.now(),
                ...data
            }
        ]);
    };

    /* DELETE VERSION */

    const deleteVersion = (id: number) => {
        setVersions(prev => prev.filter(v => v.id !== id))
    };

    /* TABLE COLUMNS */

    const columns = [
        {
            title: t('products.label_name'),
            render: () => <Input />
        },
        {
            title: t('products.col_sale_price'),
            render: () => <Input />
        },
        {
            title: t('products.col_wholesale_price'),
            render: () => <Input />
        },
        {
            title: t('products.col_cost_price'),
            render: () => <Input />
        },
        {
            title: t('products.col_promo_price'),
            render: () => <Input />
        },
        {
            title: t('products.col_unit'),
            render: () => <Input />
        },
        {
            title: t('products.col_weight'),
            render: () => <Input defaultValue="100" />
        },
        {
            title: t('products.col_quantity'),
            render: () => <Input />
        },

        /* THUỘC TÍNH */

        {
            title: t('products.col_attribute'),
            render: () => (
                <Input placeholder={t('products.placeholder_attribute')} />
            )
        },

        /* HÀNH ĐỘNG */

        {
            title: t('products.col_action'),
            render: (_: any, record: any) => (
                <div className="flex gap-2">

                    <Button
                        icon={<EditOutlined />}
                        type="text"
                        className="text-000000e0"
                    />

                    <Button
                        icon={<DeleteOutlined />}
                        type="text"
                        danger
                        onClick={() => deleteVersion(record.id)}
                    />

                </div>
            )
        }
    ];

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            ["clean"]
        ]
    };

    return (

        <Layout>
            <Helmet>
                <title>{t('page.add_product')} | Khothi</title>
            </Helmet>

            {/* HEADER */}

            <div className="flex items-center gap-3 mb-4">

                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate(-1)}
                >
                    {t('products.back')}
                </Button>

                <h2 className="text-lg font-semibold text-000000e0">
                    {t('products.create_title')}
                </h2>

            </div>

            {/* GENERAL INFO */}

            <Card
                title={t('products.general_info')}
                extra={
                    <Button
                        type="primary"
                        className="bg-[#3e91ab] hover:!bg-[#357f96] border-[#3e91ab]"
                    >
                        {t('products.save')}
                    </Button>
                }
                className="mb-6 dark:bg-[#141414]"
            >

                <Form layout="vertical">

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                        <Form.Item
                            label={t('products.label_name')}
                            required
                        >
                            <Input className="t-input" />
                        </Form.Item>

                        <Form.Item label={t('products.label_category')}>
                            <Select className="t-input"
                                placeholder={t('products.placeholder_category')}
                                options={[
                                    { label: "Làm đẹp", value: "beauty" }
                                ]}
                            />
                        </Form.Item>

                        <Form.Item label={t('products.label_status')}>
                            <Select className="t-input"
                                placeholder={t('products.placeholder_status')}
                                options={[
                                    { label: t('products.status_active'), value: "active" },
                                    { label: t('products.status_inactive'), value: "inactive" }
                                ]}
                            />
                        </Form.Item>

                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                        <Form.Item
                            label={t('products.label_unit_price')}
                            required
                        >
                            <Input className="t-input" />
                        </Form.Item>

                    </div>

                    {/* HÌNH ẢNH */}

                    <Upload
                        listType="picture-card"
                        className="mb-[24px] text-000000e0"
                    >
                        <div>
                            <UploadOutlined />
                            <div>{t('products.upload')}</div>
                        </div>
                    </Upload>

                    {/* MÔ TẢ */}

                    <Form.Item label={t('products.label_description')} className="mb-0">

                        <ReactQuill
                            theme="snow"
                            value={description}
                            onChange={setDescription}
                            modules={modules}
                            className="text-000000e0"
                        />

                    </Form.Item>

                </Form>

            </Card>

            {/* PRODUCT VERSION */}

            <Card
                title={t('products.version_title')}
                extra={
                    <Button
                        icon={<PlusOutlined />}
                        onClick={() => setOpenVersionModal(true)}
                    >
                        {t('products.add_version')}
                    </Button>
                }
                className="dark:bg-[#141414]"
            >

                <Table
                    columns={columns}
                    dataSource={versions}
                    rowKey="id"
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    className="custom-ant-table"
                />

                <ProductVersionModal
                    open={openVersionModal}
                    onClose={() => setOpenVersionModal(false)}
                    onSubmit={addVersion}
                />
            </Card>

        </Layout>
    );
}